const BARHEIGHT = 45; //导航栏高度
const CONFIG = {
  development: {
    WEBROOT: 'http://127.0.0.1',
    STATICURL: 'https://llss-mini.oss-cn-beijing.aliyuncs.com/20190912'
  },
  staging: {
    WEBROOT: 'http://127.0.0.1',
    STATICURL: 'https://llss-mini.oss-cn-beijing.aliyuncs.com/20190912'
  },
  production: {
    WEBROOT: 'http://127.0.0.1',
    STATICURL: 'https://llss-mini.oss-cn-beijing.aliyuncs.com/20190912'
  }
}

const getConfig = (name) => {
  const env = process.env.NODE_ENV
  return name ? CONFIG[env][name] : CONFIG[env]
}

export { getConfig, BARHEIGHT }
